// extracted by mini-css-extract-plugin
export default {"imageContainer":"L1-z","summaryPar":"M1-z","ratingCategories":"N1-z","reviewerInfo":"O1-z","reviewTypes":"P1-z","expanded":"Q1-z"};